// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-j_gX","advertDetailHeaderPrice__value":"c-j_gY","advertDetailHeaderPrice__label":"c-j_gZ"};